import parsePhoneNumberFromString, { getExampleNumber } from "libphonenumber-js";
import examples from 'libphonenumber-js/examples.mobile.json';
export const useValidateString = () => {
  function validateEmail(email: string): boolean {
    // Expressão regular para validar um email
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  const validateTelefone = (telefone: string) => {
    if (!telefone.trim()) {
      return { valid: false, message: "❌ Campo obrigatório" };
    }
    const phoneNumber = parsePhoneNumberFromString(telefone);

    if (!phoneNumber) {
      return { valid: false, message: "❌ Código do País não reconhecido" };
    }

    const countryCode = phoneNumber.countryCallingCode;
    const nationalNumber = phoneNumber.nationalNumber;
    const country = phoneNumber.country;
  
    if (!country) {
      return { valid: false, message: "❌ Código do País não reconhecido" };
    }
  
    const exampleNumber = getExampleNumber(country,examples);
    const exampleLength = exampleNumber ? exampleNumber.nationalNumber.length : null;
  
    if (exampleLength && nationalNumber.length !== exampleLength) {
      return {
        valid: false,
        message: `❌ Quantidade de caracteres do número de Telefone precisa conter ${exampleLength} dígitos`,
      };
    }
    return { valid: true, message: "", countryCode, nationalNumber };
  };

  return { validateEmail, validateTelefone };
};
